import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '@/views/Dashboard';
import AuthLogin from '@/views/Auth/Login';
import AuthForgotPassword from '@/views/Auth/ForgotPassword';
import AuthResetPassword from '@/views/Auth/ResetPassword';
import store from "@/store";

Vue.use(VueRouter);
const routes = [
    {
        path: '/auth/login',
        name: 'auth.login',
        component: AuthLogin,
        meta: {
            middleware: "guest",
            breadcrumb: 'Login',
        },
    },{
        path: '/auth/forgot-password',
        name: 'auth.forgot-password',
        component: AuthForgotPassword,
        meta: {
            middleware: "guest",
            breadcrumb: 'Forgot Password',
        },
    },{
        path: '/auth/reset-password/:token',
        name: 'auth.reset-password',
        component: AuthResetPassword,
        meta: {
            middleware: "guest",
            breadcrumb: 'Reset Password',
        },
    },{
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            middleware: "auth",
            breadcrumb: 'Dashboard',
        },
        redirect: {
            name: 'dashboard.home'
        },
        children: [
            {
                path: '/dashboard/home',
                name: 'dashboard.home',
                component: () => import('@/views/Home'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Home',
                },
            },{
                path: '/dashboard/products',
                name: 'dashboard.products.index',
                component: () => import('@/views/Dashboard/Products/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Products',
                },
            },{
                path: '/dashboard/orders',
                name: 'dashboard.orders.index',
                component: () => import('@/views/Dashboard/Orders/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Orders',
                }
            },{
                path: '/dashboard/deliverycharges',
                name: 'dashboard.deliverycharges',
                component: () => import('@/views/Dashboard/DeliveryCharge/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Delivery Charge',
                }
            },{
                path: '/dashboard/stock-notices',
                name: 'dashboard.stock-notice',
                component: () => import('@/views/Dashboard/StockNotice/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Stock Notices',
                }
            },{
                path: '/dashboard/delivery-excluded-dates',
                name: 'dashboard.delivery-excluded-dates',
                component: () => import('@/views/Dashboard/DeliveryExcludedDate/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Excluded Dates',
                }
            },{
                path: '/dashboard/delivery-rate-requests',
                name: 'dashboard.delivery-rate-requests',
                component: () => import('@/views/Dashboard/DeliveryRateRequest/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Delivery Rate Requests',
                }
            },{
                path: '/dashboard/postcode-groupings',
                name: 'dashboard.postcode-groupings',
                component: () => import('@/views/Dashboard/PostcodeGrouping/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Postcode Groupings',
                }
            },{
                path: '/dashboard/product-groupings',
                name: 'dashboard.product-groupings',
                component: () => import('@/views/Dashboard/ProductGrouping/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Product Groupings',
                }
            },{
                path: '/dashboard/buildservices',
                name: 'dashboard.buildservices',
                component: () => import('@/views/Dashboard/BuildService/Index'),
                meta: {
                    middleware: "auth",
                    breadcrumb: 'Build Services',
                }
            }
        ],
    },{
        path: '/',
        redirect: {
            name: 'dashboard.home'
        }
    },{
        path: '/app',
        redirect: {
            name: 'dashboard.home'
        }
    }
];

let router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    let siteName = process.env.MIX_APP_NAME ?? 'QFConnector';
    document.title = `${to.meta.breadcrumb} – ${siteName}`
    if(to.meta.middleware === "guest") {
        if(store.state.auth.authenticated) {
            next({name: "dashboard.home" });
        }
        next();
    } else {
        if(store.state.auth.authenticated) {
            next();
        } else {
            next({name: "auth.login" });
        }
    }
})

export default router;
